import { NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ReactiveFormsModule, UntypedFormControl } from '@angular/forms';

import { CheckboxComponent } from '../checkbox/checkbox.component';

@Component({
  selector: 'rt-selectable-card',
  templateUrl: './selectable-card.component.html',
  styleUrls: ['./selectable-card.component.less'],
  standalone: true,
  imports: [NgIf, CheckboxComponent, ReactiveFormsModule],
})
export class SelectableCardComponent {
  @Input() public control: UntypedFormControl;
  @Input() public disabled: boolean = false;
  @Input() public label: string;
  @Input() public description: string;

  @Output() public valueChanges: EventEmitter<string | boolean | null> = new EventEmitter();
}
